import { createFileRoute } from '@tanstack/react-router';
import { Login } from '../../organisms/Login';
import z from 'zod';

const loginSearchSchema = z.object({
  code: z.string().optional(),
  state: z.union([z.string(), z.object()]).optional(),
  token: z.string().optional(),
  email: z.string().optional(),
});

export const Route = createFileRoute('/_unauthenticated/login')({
  component: Login,
  validateSearch: (search) => loginSearchSchema.parse(search)
});
